import {
  Flex,
  Text,
  Collapse,
  Box,
  useDisclosure,
  useToast,
  Spacer,
  Icon,
  Button,
} from "@chakra-ui/react";
import { BsXCircleFill } from "react-icons/bs";

import React, { useState, useEffect } from "react";
import { IoIosSend } from "react-icons/io";

import { axiosPost } from "utils/api";
import AddBackupEmail from "./AddBackupEmail";
import { ROOT_API } from "utils/constant";
import { API_ROUTES } from "utils/constant";
import SendEmailTestModal from "./SendEmailTestModal";
import { FaExchangeAlt } from "react-icons/fa";

function ExpandedRow(props) {
  const { data, refetch, emailBackup, smtpId } = props;
  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenSendMailModal,
    onOpen: onOpenSendMailModal,
    onClose: onCloseSendMailModal,
  } = useDisclosure();

  const [selectedEmail, setSelectedEmail] = useState();

  const handleEditEmailBackup = (email) => {
    onOpen();
    setSelectedEmail(email);
  };

  const handleDeleteEmail = async (e, email) => {
    e.stopPropagation();
    if (window.confirm("Are you sure to remove this email")) {
      try {
        const dataDelete = {
          id: smtpId,
          backupId: email?._id,
        };
        const response = await axiosPost(
          ROOT_API + API_ROUTES.SMTP_SERVER_DELETE_BACKUP_EMAIL,
          dataDelete
        );
        if (response?.data?.code == 0) {
          toast({
            title: "Delete Email Backup Successfully",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          refetch();
        }
      } catch (error) {
        console.log(error);
        toast({
          title:
            error?.response?.data?.errors?.errors[0]?.msg ||
            error?.response?.data?.msg ||
            "Delete Email Backup Fail",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    }
  };

  const handleChangeLimit = async (e, idEmail) => {
    e.stopPropagation();
    if (window.confirm("Are you sure to change the limit for this email")) {
      try {
        const dataPayload = {
          id: smtpId,
          smtpBackUpId: idEmail,
        };
        const response = await axiosPost(
          ROOT_API + API_ROUTES.CHANGE_LIMIT,
          dataPayload
        );
        if (response?.data?.code == 0) {
          toast({
            title: "Change limit email Backup Successfully",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          refetch();
        }
      } catch (error) {
        console.log(error);
        toast({
          title:
            error?.response?.data?.errors?.errors[0]?.msg ||
            error?.response?.data?.msg ||
            "Change limit email Backup Fail",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    }
  };


  const closeSendMailModal = () => {
    setSelectedEmail(null);
    onCloseSendMailModal();
  };

  return (
    <>
      <Collapse in={true}>
        <Flex columnGap={2}>
          {emailBackup?.length
            ? emailBackup.map((email, index) => (
                <Box>
                  <Box
                    cursor={"pointer"}
                    display={"flex"}
                    flexDirection={"column"}
                    flex={1}
                    bg={"blue.400"}
                    px={2}
                    rowGap={1}
                    py={2}
                    justifyContent={"center"}
                    // alignItems={"center"}
                    color={"white"}
                    borderRadius={6}
                    onClick={() => handleEditEmailBackup(email)}
                    position={"relative"}
                    maxW={"200px"}
                    minW="200px"
                  >
                    <Text
                      whiteSpace="break-spaces"
                      wordBreak="break-all"
                    >{`SMTP ID: ${email._id}`}</Text>
                    <Text
                      whiteSpace="break-spaces"
                      wordBreak="break-all"
                    >{`Email: ${email.authUserEmail}`}</Text>
                    <Text>{`Password: ${
                      email?.authUserPassword || "N/A"
                    }`}</Text>
                    <Text>{`Email Sent In Day: ${email?.mailSentInDay}`}</Text>
                    <Text>{`Reach the Limit: ${
                      email?.isLimit ? "Yes" : "No"
                    }`}</Text>
                    <Icon
                      as={BsXCircleFill}
                      position={"absolute"}
                      right={0}
                      top={0}
                      onClick={(e) => handleDeleteEmail(e, email)}
                    />
                    <Flex justifyContent={"center"}>
                      <Button
                        p="0px"
                        bg="transparent"
                        variant="no-effects"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedEmail(email);
                          onOpenSendMailModal();
                        }}
                      >
                        <IoIosSend size={16} />
                      </Button>
                      <Button
                        p="0px"
                        bg="transparent"
                        variant="no-effects"
                        onClick={(e) => handleChangeLimit(e, email._id)}
                      >
                        <FaExchangeAlt size={16} />
                      </Button>
                    </Flex>
                  </Box>
                </Box>
              ))
            : ""}
        </Flex>
      </Collapse>
      <AddBackupEmail
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        fetchData={refetch}
        smtpId={smtpId}
        smtpSetting={selectedEmail}
      />
      {isOpenSendMailModal && (
        <SendEmailTestModal
          isOpen={isOpenSendMailModal}
          onOpen={onOpenSendMailModal}
          onClose={closeSendMailModal}
          fetchData={refetch}
          smtpId={smtpId}
          smtpBackUpId={selectedEmail?._id}
        />
      )}
    </>
  );
}

export default ExpandedRow;
